import FileSaver from "file-saver";
import {api as config} from "../../../SiteConfig/siteConstants";
import {downloadUtility} from "./downloadUtility"
import type {AjaxRequestOptions} from "./ajaxRequestOptions";

export const ajaxBlobRequest = (notificationFactory: { createSuccess: (msg: string) => { notify: () => void }; createError: (msg: string) => { notify: () => void }; createErrorsFromXhrObject: (errors: unknown) => { notify: () => void } }, maxRetryCount = config.RETRIES, retryTimeout = 150) => {
	async function send(ajaxRequestOptions: AjaxRequestOptions): Promise<Blob | undefined> {
		try {
			const fetchOptions: RequestInit = {
				method: ajaxRequestOptions.type,
				headers: ajaxRequestOptions.headers,
				body: ajaxRequestOptions.data as BodyInit | undefined
			};

			for (let i = 0; i < maxRetryCount; i++) {
				const response = await fetch(ajaxRequestOptions.url, {
						...fetchOptions,
						credentials: 'include', 
						headers: {
							...fetchOptions.headers as Record<string, string>,
							'Content-Type': ajaxRequestOptions.contentType || 'application/json'}
					});

				if (response.ok) {
					const blob = await response.blob();

					let filename = downloadUtility.getFilenameFromHeader(response);
		
					FileSaver.saveAs(blob, filename);

					if (ajaxRequestOptions.successMessage) {
						notificationFactory.createSuccess(ajaxRequestOptions.successMessage).notify();
					}

					return blob;
				} else if (response.status === 401) {
					notificationFactory.createError("Your session has expired. Please sign in again.").notify();
					window.location.href = "/sign-in";
					return;
				} else {
					if (i < maxRetryCount - 1) {
						await new Promise(resolve => setTimeout(resolve, retryTimeout));
						
					} else {
						const errorText = await response.text();
						notificationFactory.createErrorsFromXhrObject(errorText).notify();
					}
				}
			}
		} catch (error) {
			notificationFactory.createError("Error fetching data").notify();
			throw error;
		}
	}

	return { send };
};
